// @flow
import actionTypes from './actionTypes';

export function extendActionTypes(newActions: Object, baseActions: Object) {
  const keys = Object.keys(newActions);
  keys.forEach(key => {
    if (baseActions[key]) {
      throw new Error(
        `You are trying to use ${key} a proctected action type name`
      );
    }
  });
  return { ...baseActions, ...newActions };
}

export default (a: Object) => extendActionTypes(a, actionTypes);



// WEBPACK FOOTER //
// ./~/virgo/src/actions/extendActionTypes.js